// @flow
import React, { Component, type AbstractComponent } from 'react';
import type { HocRouteDataType } from 'app/common/lib/routing/routeDataTypes';
import View from 'app/common/lib/react/View';
import { Route } from 'app/common/lib/ReactRouter/route';

type RouteProps = {|
  route: Route,
  // $FlowFixMe Flow v0.104.0 upgrade supression.
  params: *,
  // $FlowFixMe Flow v0.104.0 upgrade supression.
  location: *,
|};

export default function withRouteData(routeData: HocRouteDataType) {
  const {
    name,
    upwtActionName,
    resourceDependencies = () => [],
    routeContextLog = (legacy_server_context, params, location) => null,
    metatagResource = () => null,
    redirect = () => null,
    getRenderError = () => null,
  } = routeData;

  return function withRouteData<SubjectProps: $Shape<RouteProps>>(
    Subject: AbstractComponent<SubjectProps>,
  ): AbstractComponent<{| ...SubjectProps, ...RouteProps |}> {
    return class StaticRouteData extends Component<{| ...SubjectProps, ...RouteProps |}> {
      static WrappedComponent = Subject;
      static routeName = name;
      // TODO(jchan): Temporary until we make UPWT play more idiomatically with pure react
      static upwtActionName = upwtActionName;
      static displayName = 'StaticRouteData';
      static getMetatagResource = metatagResource;
      static getContextLog = routeContextLog;
      static getResourceDependencies = resourceDependencies;
      static getRedirect = redirect;
      static getRenderError = getRenderError;

      render() {
        const { params, location = {} } = this.props;
        const { legacy_server_context } = this.props.route || {};
        return (
          <View log={routeContextLog(legacy_server_context || {}, params || {}, location || {})}>
            <Subject {...this.props} />
          </View>
        );
      }
    };
  };
}
